// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChangePassword_wrapper__1Cw5W","wrapperForm":"ChangePassword_wrapperForm__3f7Jk"};